import {
  getGlobalFeatureFlags as getGlobalFeatureFlagsApi,
  updateGlobalFeatureFlag as updateGlobalFeatureFlagApi,
  getGlobalFeatureFlagAccounts as getGlobalFeatureFlagAccountsApi,
  getAccountFeatureFlags as getAccountFeatureFlagsApi,
  updateAccountFeatureFlags as updateAccountFeatureFlagsApi,
} from '../api/feature-flag.api'

export const getGlobalFeatureFlags = () => {
  return (dispatch) => {
    return getGlobalFeatureFlagsApi()
  }
}

export const updateGlobalFeatureFlag = (key, value) => {
  return (dispatch) => {
    return updateGlobalFeatureFlagApi(key, value)
  }
}

export const getGlobalFeatureFlagAccounts = (key) => {
  return (dispatch) => {
    return getGlobalFeatureFlagAccountsApi(key)
  }
}

export const getAccountFeatureFlags = (accountId) => {
  return (dispatch) => {
    return getAccountFeatureFlagsApi(accountId)
  }
}

export const updateAccountFeatureFlags = (accountId, overrides) => {
  return (dispatch) => {
    return updateAccountFeatureFlagsApi(accountId, overrides)
  }
}
